/* eslint-disable */
export default {
  currentCall: 'Nykyinen puhelu',
  viewCalls: 'Näytä puhelut',
  view: 'Näytä',
  incomingCall: '{numberOf} saapuva puhelu',
  incomingCalls: '{numberOf} saapuvaa puhelua',
  callOnHold: '{numberOf} puhelu pidossa',
  callsOnHold: '{numberOf} puhelua pidossa',
  otherDeviceCall: '{numberOf} puhelu muilla laitteilla',
  otherDeviceCalls: '{numberOf} puhelua muilla laitteilla',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
